import { getCategoryDetail } from "../../../../lib/admin";
import { Category } from "../../../../types";
import StoreReportDetails, { DetailBox, DetailFields, formatDetailDate } from "../shared/StoreReportDetails";
import { useReportDetail } from "../hooks/useReportDetail";

type Props =
    {
        storeId: number
        category: Category
    }

export default function StoreReportCategoryDetails({ storeId, category }: Props) {
    const { detail, isLoading, error } = useReportDetail(
        () => getCategoryDetail(storeId, category.id),
        `${storeId}:${category.id}`,
        "Could not load the details of this category.",
    );

    const subCategories = detail?.subCategories ?? [];

    return (
        <StoreReportDetails mirrorError={category.error} isLoading={isLoading} error={error}>
            {(showRaw) => detail && (
                <div className="product-details-grid">
                    <DetailBox title="In Shopify" source={detail.shopify} found={detail.shopify.found} error={detail.shopify.error} showRaw={showRaw}>
                        <DetailFields entries={[
                            ["Kind", detail.shopify.kind ?? ""],
                            ["Title", detail.shopify.title ?? ""],
                            ["Handle", detail.shopify.handle ?? ""],
                            ["Updated", formatDetailDate(detail.shopify.updatedAt)],
                            ["Published", formatDetailDate(detail.shopify.publishedAt)],
                        ]} />
                    </DetailBox>
                    <DetailBox title="On index" source={detail.index} found={detail.index.found} error={detail.index.error} showRaw={showRaw}>
                        <DetailFields entries={[["Indexed products", `${detail.index.products ?? 0}`]]} />
                    </DetailBox>
                    <div className="product-details-wide">
                        <DetailBox title="Subcategories" source={subCategories} found={true} error={null} showRaw={showRaw}>
                            {subCategories.length === 0
                                ? <p className="product-details-message">None</p>
                                : (
                                    <dl className="product-details-fields">
                                        {subCategories.map((subCategory) => (
                                            <div key={subCategory.id}>
                                                <dt>{subCategory.name}</dt>
                                                <dd>{subCategory.handle || "No handle yet"}</dd>
                                            </div>
                                        ))}
                                    </dl>
                                )}
                        </DetailBox>
                    </div>
                </div>
            )}
        </StoreReportDetails>
    );
}
